// Duplicate page
export const DUPLICATE_DSR_PAGE_REQUEST = 'duplicate_dsr_page_request';
export const DUPLICATE_DSR_PAGE_SUCCESS = 'duplicate_dsr_page_success';
export const DUPLICATE_DSR_PAGE_FAILURE = 'duplicate_dsr_page_failure';
export const DUPLICATE_DSR_PAGE_RESET = 'duplicate_dsr_page_reset';